
import config from '../config'; 

const URL_CATEGORIES = `${config.URL_BACKEND_TOP}/categorias`;

function getAllWithVideos() {
    return fetch(`${URL_CATEGORIES}?_embed=videos`)
        .then(async (data) => {

            if(data.ok) {
                const resposta = await data.json();
                return resposta;
            }

            throw new Error("Não foi possível pegar os dados");
        });
}

export default {
    getAllWithVideos,
} 
